export type OS = 'WINDOWS' | 'MACOS' | 'OTHER';

export function getCurrentOS(): OS {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('win')) return 'WINDOWS';
  if (ua.includes('mac')) return 'MACOS';
  return 'OTHER';
}

export function isBlockedByOS(requiredOS?: string[]): boolean {
  if (!Array.isArray(requiredOS) || requiredOS.length === 0) return false;
  return !requiredOS.map(o => String(o).toUpperCase()).includes(getCurrentOS());
}

export function shouldShowWarning(warningMessage?: string, requiredOS?: string[]): boolean {
  if (typeof warningMessage !== 'string' || !warningMessage?.trim()) return false;
  if (!Array.isArray(requiredOS) || requiredOS.length === 0) return true;
  return isBlockedByOS(requiredOS);
}
